import config from './../config/development.js';

export default {
  "btn.login": "ログイン",
  "btn.search": "検索",
  "btn.check": "確認",
  "btn.infoCheck": "確認",
  "btn.back": "戻る",
  "btn.update": "更新",
  "btn.detail": "詳細",
  "btn.delete": "削除",
  "btn.add": "追加",
  "btn.copy": "コピー登録",
  "btn.output": "出力",
  "btn.edit": "編集",
  "btn.newFormat": "フォーマットの新規作成",
  "btn.clear": "クリア",
  "btn.cancel": "取消",
  "btn.copyin": "コピー登録",
  "btn.set": "設定",
  "btn.view": "表示",
  "btn.input": "取込",
  "btn.reference": "参照",
  "btn.redisplay": "再表示しない",
  "btn.register": "登録",
  "btn.approval": "承認",
  "btn.approvalCancel": "承認取消",
  "btn.upload": "アップロード",
  "btn.selectFile": "ファイルを選択",
  "btn.read": "読取",

  "login.title": "ログイン",
  "account.title": "アカウント管理",
  "list.title": "リスト一覧",
  "regist.title": "サンプル",
  "regist2.title": "サンプル２",
  "rekognition.title": "画像認識",

  "login.label.loginid": "ログインID",
  "login.label.password": "パスワード",
  
  "account.label.lastname": "氏名（姓）",
  "account.label.firstname": "氏名（名）",
  "account.label.address": "住所",
  "account.label.age": "年齢",
  "account.label.email": "メールアドレス",
  "account.label.count": "個数",
  "account.label.sex": "性別",
  "account.label.hobby": "趣味",

  "account.item.sex.male": "男性",
  "account.item.sex.female": "女性",
  "account.item.hobby.movie": "映画鑑賞",
  "account.item.hobby.drive": "ドライブ",

  "list.columns.download": "DL",
  "list.columns.name": "氏名",
  "list.columns.count": "件数",

  "timestamp.label.detail": "詳細は",
  "timestamp.label.this": "こちら",
  
  "infoadd.columns.QR":"QR",
  "infoadd.columns.yomitori":"読取",
  "infoadd.columns.name":"個人番号・氏名",
  "infoadd.columns.kojinNum":"個人番号",
  "infoadd.columns.representative":"代表者",
  
  "infoadd.label.shelterName":"避難所名",
  "infoadd.label.admissionData":"入所日時",
  "infoadd.label.districtName":"地区名",
  "infoadd.label.chonaikaiName":"町内会名",
  "infoadd.label.jichikaiName":"自治会名",
  "infoadd.label.address":"住所",
  "infoadd.label.personalNameEC":"緊急連絡先（氏名）",
  "infoadd.label.addressEC":"緊急連絡先（住所）",
  "infoadd.label.numberEC":"緊急連絡先（電話番号）",
  "infoadd.label.relationshipEC":"緊急連絡先（続柄）",
  "infoadd.label.representativeName":"世帯主氏名(漢字)",
  "infoadd.label.representativeHira":"世帯主氏名(ひらがな)",
  "infoadd.label.representativeKana":"世帯主氏名(カタカナ)",
  "infoadd.label.entryName":"記入者氏名(漢字)",
  "infoadd.label.entryHira":"記入者氏名(ひらがな)",
  "infoadd.label.entryKana":"記入者氏名(カタカナ)",
  "infoadd.label.homePhoneNumber":"電話番号(自宅)",
  "infoadd.label.faxNumber":"FAX番号(自宅)",
  "infoadd.label.evacuationType":"避難種別",
  "infoadd.label.transportation":"避難所までの交通手段",
  "infoadd.label.otherTransportation":"避難所までの交通手段(その他)",
  "infoadd.label.cars":"避難所までの交通手段(自動車の場合の台数)",
  "infoadd.label.carModel":"避難所までの交通手段(自動車の場合の車種)",
  "infoadd.label.carColor":"避難所までの交通手段(自動車の場合の色)",
  "infoadd.label.carNumberPlate":"避難所までの交通手段(自動車の場合のナンバー)",
  "infoadd.label.parking":"避難所までの交通手段(自動車の場合の駐車エリア)",
  "infoadd.label.pet":"ペットの状況",
  "infoadd.label.petState":"ペットがいる場合",
  "infoadd.label.houseDamage":"自宅の被害状況",
  "infoadd.label.infraDamage":"自宅の被害状況(水道・電気・ガス・電話)",
  "infoadd.label.otherDamage":"自宅の被害状況(その他)",
  "infoadd.label.citizen":"市民・それ以外",
  "infoadd.label.UUID":"UUID",
  "infoadd.label.representative":"代表者",
  "infoadd.label.personalName":"氏名(漢字)",
  "infoadd.label.personalHira":"氏名(ひらがな)",
  "infoadd.label.personalKana":"氏名(カタカナ)",
  "infoadd.label.gender":"性別",
  "infoadd.label.birthDate":"生年月日",
  "infoadd.label.birthDateYear":"　年",
  "infoadd.label.birthDateMonth":"　月",
  "infoadd.label.birthDateDay":"　日",
  "infoadd.label.age":"年齢(入所時時点)",
  "infoadd.label.age2":"　歳",
  "infoadd.label.telephoneNumber":"携帯電話番号",
  "infoadd.label.relationship":"続柄",
  "infoadd.label.nationality":"国籍",
  "infoadd.label.otherNationality":"国籍(その他)",
  "infoadd.label.language":"使用できる言語",
  "infoadd.label.evacuationForm":"避難形態",
  "infoadd.label.otherEvacuationForm":"避難形態(その他)",
  "infoadd.label.place":"滞在を希望する場所",
  "infoadd.label.otherPlace":"滞在を希望する場所(その他)",
  "infoadd.label.foods":"食料、物資の配布希望有無",
  "infoadd.label.otherFoods":"食料、物資の配布希望有無（その他）",
  "infoadd.label.disease":"病気（病名）",
  "infoadd.label.injury":"けが",
  "infoadd.label.shoniIryo":"小児医療",
  "infoadd.label.jinkoToseki":"人工透析",
  "infoadd.label.sansoRyoho":"酸素療法",
  "infoadd.label.fujinkaIryo":"産婦人科医療",
  "infoadd.label.seishinIryo":"精神科医療",
  "infoadd.label.feverCough":"熱・咳の有無",
  "infoadd.label.kaigo":"要介護認定・要介護度",
  "infoadd.label.deficiency":"入れ歯・眼鏡の不備",
  "infoadd.label.risk":"感染症罹患時の重症化リスク",
  "infoadd.label.bloodType":"血液型",
  "infoadd.label.medicine":"服用している薬の有無",
  "infoadd.label.medicineName":"服用している薬の名前",
  "infoadd.label.allergy":"アレルギー（薬・食物）",
  "infoadd.label.disabled":"障がい手帳の級",
  "infoadd.label.iryokiki":"医療機器使用者",
  "infoadd.label.pregnancy":"妊娠",
  "infoadd.label.child":"乳幼児・児童",
  "infoadd.label.request":"それ以外の配慮事項・相談事項、希望",
  "infoadd.label.cooperation":"運営に協力できること",
  "infoadd.label.otherCooperation":"運営に協力できること(資格・特技など)",
  "infoadd.label.free":"その他",
  "infoadd.label.information":"問い合わせがあった場合に避難していることをお知らせに関する可否",
  "infoadd.label.disclosure":"情報の開示に対する同意",
  "infoadd.label.spare1R":"予備（代表）１",
  "infoadd.label.spare2R":"予備（代表）２",
  "infoadd.label.spare3R":"予備（代表）３",
  "infoadd.label.spare4R":"予備（代表）４",
  "infoadd.label.spare5R":"予備（代表）５",
  "infoadd.label.spare1":"予備１",
  "infoadd.label.spare2":"予備２",
  "infoadd.label.spare3":"予備３",
  "infoadd.label.spare4":"予備４",
  "infoadd.label.spare5":"予備５",
  
  "infoadd.explanation":"ここに説明文が入る\n改行可能",
  
  "infoupd.columns.name":"個人番号・氏名",
  "infoupd.columns.representative":"代表者",
  "infoupd.columns.status":"ステータス",
  

  "infoupd.explanation":"ここに説明文が入る\n改行可能",

  "dialog.error.noRegisterData":"個人用QRコードを読取していない行があります\n個人用QRコードを読取するか行を削除してください",
  "dialog.error.notDeleteRow":"これ以上削除できません",
  "dialog.error.representative":"代表者を１名選択してください",
  "dialog.error.requiredPersonalName":"氏名を入力してください({values}行目)",
  "dialog.error.duplicatePersonalNumber":"同じ個人用QRコードを読取している行があります\n個人番号を確認して、重複している番号の行に異なる個人用QRコードを再読取するか、行を削除してください",

  "const.space": "",
  
  //Infomation
  "dialog.click.btnGet" : "説明です",
  "dialog.noSelectedFile.error": "ファイルを選択してください",
  "dialog.import.completion": "ファイルのアップロードが完了しました",
  "dialog.status400.error400": "エラーが発生しました\n{code}\n{message}",
  "dialog.status400.errorElse": "エラーが発生しました",
  "dialog.status429": "ただいま混みあっています\nしばらく時間を空けてから再度お試しください",
  "dialog.status429.errorElse": "エラーが発生しました\n繰り返し発生する場合は管理者へ問い合わせください",
  "dialog.status429.errorElse.duplicatePersonalNumber": "既に登録済のカードを読み取っている可能性があります",
  "dialog.statusElse": "システムエラーが発生しました",
  
};